import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from 'src/app/services/role.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { TournamentDrawService } from 'src/app/services/tournament-draw.service';
import { CategoryService } from 'src/app/services/category.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { ConfirmationService, MessageService } from 'primeng/api';
@Component({
  selector: 'app-tournament-draw-view',
  templateUrl: './tournament-draw.component.html',
  styleUrls: ['./tournament-draw.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class TournamentDrawComponent implements OnInit {
  entry = { index: 1 }; // Sample entry with index
  dynamicId: string;
  window: any;
  showingmodal: boolean = false;
  public categoryList;
  public ageGroupList;
  submitted = false;
  factSheetForm: FormGroup;
  drawForm: FormGroup;
  scoreForm: FormGroup;
  scoreInputForm: FormGroup;
  activeIndex: number = 0;
  public errorMessage;
  public role;
  public roleId;
  public playerList: any[] = [];
  public selectedPlayerList: any[] = [];
  public playerId;
  public oldPlayer;
  public showInfo: boolean = false;
  public disableDropDown: boolean = false;
  public totalEntries;
  public totalEntriesArray: any[] = [];
  public secondRoundArray: any[] = [];
  public thirdRoundArray: any[] = [];
  public fourthRoundArray: any[] = [];
  public fifthRoundArray: any[] = [];
  public sixthRoundArray: any[] = [];
  public seventhRoundArray: any[] = [];
  public eightRoundArray: any[] = [];
  public roundResult: any[] = [];
  public tournamentId;
  public items;
  public selectedGroupId;
  public selectedAgeGroupId;
  public showScoreForm: boolean = false;
  public playerOneDetails;
  public playerTwoDetails;
  public showScoreInputError: boolean = false;
  public matchConcedeCategories: any = [];
  public selectedMatchConcedeCategory;
  public selectedPlayerValue;
  public showPlayerRadioButtons: boolean = false;
  public playerScoreArray: any = [];
  public showSetScoreTable: boolean = false;
  public totalSets: any = [];
  public playerPosition;
  public showDetailScoringCheckBox: boolean = true;
  public playerOneId;
  public playerTwoId;
  public playerOneInputValue: number = 0;
  public playerTwoInputValue: number = 0;
  public round;
  public result;
  public formControlNumberOne;
  public formControlNumberTwo;
  public countForBye: any = 0;
  public tournamentName;
  public drawStatus: boolean = true;
  @ViewChild('playerOneResetButton') playerOneResetButton: ElementRef;
  @ViewChild('playerTwoResetButton') playerTwoResetButton: ElementRef;
  @ViewChild('playerTwoDropDown') playerTwoDropDown: ElementRef;
  categoryAndAgeGroupList: any[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private roleService: RoleService,
    private elementRef: ElementRef,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private tournamentService: TournamentsService,
    private tournamentDrawService: TournamentDrawService,
    private categoryService: CategoryService,
    private tokenStorageService: TokenStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) { 
    // this.updateDynamicId();
  }

  ngOnInit(): void {
    this.factSheetForm = this.formBuilder.group({
      categoryType: ['', [Validators.required]],
      ageGroup: ['', [Validators.required]]
    });
    this.scoreForm = this.formBuilder.group({
      playerOne: ['',],
      playerTwo: ['',],
      matchConcedeCategoryDropDown: [],
      matchConcedeCategoryCheckbox: [],
      playerOneRadio: [],
      playerTwoRadio: []
    });
    this.tournamentId = this.activeRoute.snapshot.paramMap.get('id');
    this.drawForm = this.formBuilder.group({
      // categoryType: ['', [Validators.required]],
      // ageGroup: ['', [Validators.required]],
      categoryAndAgeGroup: ['', [Validators.required]]
    });
    this.scoreInputForm = this.formBuilder.group({
      scoreArray: this.formBuilder.array([])
    });
    this.getRoles();
    this.getTournamentDetails(this.tournamentId);
    // this.getTournamentCategory(this.tournamentId);
    this.getTournamentCategoryV2(this.tournamentId);
    this.getTournamentMatchConcedeCategories();
  }
  get f() {
    return this.drawForm.controls;
  }
  scoreSectionForm(): FormArray {
    return this.scoreInputForm.get("scoreArray") as FormArray;
  }
  async getTournamentDetails(id) {
    this.tournamentService.getTournamentDetailsByID(id).subscribe(res => {
      this.items = res;
      this.tournamentName = this.items.name;

    })
  }
  async getTournamentCategory(id) {
    let query = "getMatchtype=true";
    this.tournamentService.getTournamentCategory(id, query).subscribe(
      data => {
        if (data) {
          this.categoryList = data.items;
        }
      },
      (err) => {
      }
    );
  }

  async getTournamentCategoryV2(id) {
    this.tournamentService.getTournamentCategoryV2(id).subscribe(
      data => {
        if (data) {
          this.categoryAndAgeGroupList = data;
        }
      },
      (err) => {
      }
    );
  }

  getTournamentMatchConcedeCategories() {
    let parentList = this.tokenStorageService.getCategorylist();
    let obj = parentList.find(o => o.slug === "match_conceded_type");
    if (obj.id) {
      let query = "?filterByDisable=false&filterByStatus=true&filterByParent=" + obj.id + "&sortBy=created_at&orderBy=1";
      this.categoryService.getCategoryList(query).subscribe(
        data => {
          let matchConcedeCategories = data.data.items;
          matchConcedeCategories.forEach(element => {
            this.matchConcedeCategories.push({ name: element.name, value: element.id, slug: element.slug });
          })
        },
        err => {
          this.errorMessage = err.error.message;
        }
      );
    }
  }
  onSelectCategory(event) {
    this.selectedGroupId = event.value.matchTypeId;
    let query = "getAgeGroup=true&matchtype=" + event.value.matchTypeId;
    this.tournamentService.getTournamentCategory(this.tournamentId, query).subscribe(
      data => {
        if (data) {
          this.totalEntries = '';
          this.totalEntriesArray = [];
          this.secondRoundArray = [];
          this.thirdRoundArray = [];
          this.fourthRoundArray = [];
          this.fifthRoundArray = [];
          this.sixthRoundArray = [];
          this.seventhRoundArray = [];
          this.playerOneDetails = [];
          this.playerTwoDetails = [];
          this.selectedPlayerList = [];
          this.playerList = [];
          this.ageGroupList = data.items;
        }
      },
      (err) => {
      });
  }
  onAgeGroupSelect(event) {
    this.totalEntries = '';
    this.totalEntriesArray = [];
    this.secondRoundArray = [];
    this.thirdRoundArray = [];
    this.fourthRoundArray = [];
    this.fifthRoundArray = [];
    this.sixthRoundArray = [];
    this.seventhRoundArray = [];
    this.eightRoundArray = [];
    this.playerOneDetails = [];
    this.playerTwoDetails = [];
    this.selectedPlayerList = [];
    this.playerList = [];
    this.selectedAgeGroupId = event.value.ageGroupId;
    this.totalEntries = event.value.maxPlayer;
    for (let i = 0; i < this.totalEntries; i++) {
      let control = "player" + (i + 1);
      this.drawForm.addControl(control, new FormControl());
      this.drawForm.addControl("reset_player" + (i + 1), new FormControl());
      this.drawForm.addControl("reset_player" + (i + 1) + "_position", new FormControl());
      this.drawForm.get(control).disable();
      this.totalEntriesArray.push(i);
    }
    let secondRound = Number(this.totalEntries) / 2;
    let index = 1;
    for (let i = 0; i < secondRound; i++) {
      this.secondRoundArray.push({ index: index });
      index = index + 2;
    }
    let thirdIndex = 1;
    let thirdRound = Number(secondRound) / 2;
    for (let i = 0; i < thirdRound; i++) {
      this.thirdRoundArray.push({ index: thirdIndex });
      thirdIndex = thirdIndex + 4;
    }
    let fourthIndex = 1;
    let fourthRound = Number(thirdRound) / 2;
    for (let i = 0; i < fourthRound; i++) {
      this.fourthRoundArray.push({ index: fourthIndex });
      fourthIndex = fourthIndex + 8;
    }
    if (Number(this.totalEntries) === Number(16) || Number(this.totalEntries) === Number(32) || Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
      let fifthIndex = 1;
      let fifthRound = Number(fourthRound) / 2;
      for (let i = 0; i < fifthRound; i++) {
        this.fifthRoundArray.push({ index: fifthIndex });
        fifthIndex = fifthIndex + 16;
      }
      if (Number(this.totalEntries) === Number(32) || Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
        let sixthIndex = 1;
        let sixthRound = Number(fifthRound) / 2;
        for (let i = 0; i < sixthRound; i++) {
          this.sixthRoundArray.push({ index: sixthIndex });
          sixthIndex = sixthIndex + 32;
        }
        if (Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
          let seventhIndex = 1;
          let seventhRound = Number(sixthRound) / 2;
          for (let i = 0; i < seventhRound; i++) {
            this.seventhRoundArray.push({ index: seventhIndex });
            seventhIndex = seventhIndex + 64;
          }
          if (Number(this.totalEntries) === Number(128)) {
            let eightIndex = 1;
            let eightRound = Number(seventhRound) / 2;
            for (let i = 0; i < eightRound; i++) {
              this.eightRoundArray.push({ index: eightIndex });
              eightIndex = seventhIndex + 128;
            }
          }
        }
      }

    }
    this.getPlayers(this.selectedAgeGroupId);
  }

  onselectGetCategoryV2(event) {
    this.totalEntries = '';
    this.totalEntriesArray = [];
    this.secondRoundArray = [];
    this.thirdRoundArray = [];
    this.fourthRoundArray = [];
    this.fifthRoundArray = [];
    this.sixthRoundArray = [];
    this.seventhRoundArray = [];
    this.eightRoundArray = [];
    this.playerOneDetails = [];
    this.playerTwoDetails = [];
    this.selectedPlayerList = [];
    this.playerList = [];
    this.selectedAgeGroupId = event.value.ageGroupId;
    this.selectedGroupId = event.value.matchTypeId;
    this.totalEntries = event.value.maxPlayer;
    for (let i = 0; i < this.totalEntries; i++) {
      let control = "player" + (i + 1);
      this.drawForm.addControl(control, new FormControl());
      this.drawForm.addControl("reset_player" + (i + 1), new FormControl());
      this.drawForm.addControl("reset_player" + (i + 1) + "_position", new FormControl());
      this.drawForm.get(control).disable();
      this.totalEntriesArray.push(i);
    }
    let secondRound = Number(this.totalEntries) / 2;
    let index = 1;
    for (let i = 0; i < secondRound; i++) {
      this.secondRoundArray.push({ index: index });
      index = index + 2;
    }
    let thirdIndex = 1;
    let thirdRound = Number(secondRound) / 2;
    for (let i = 0; i < thirdRound; i++) {
      this.thirdRoundArray.push({ index: thirdIndex });
      thirdIndex = thirdIndex + 4;
    }
    let fourthIndex = 1;
    let fourthRound = Number(thirdRound) / 2;
    for (let i = 0; i < fourthRound; i++) {
      this.fourthRoundArray.push({ index: fourthIndex });
      fourthIndex = fourthIndex + 8;
    }
    if (Number(this.totalEntries) === Number(16) || Number(this.totalEntries) === Number(32) || Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
      let fifthIndex = 1;
      let fifthRound = Number(fourthRound) / 2;
      for (let i = 0; i < fifthRound; i++) {
        this.fifthRoundArray.push({ index: fifthIndex });
        fifthIndex = fifthIndex + 16;
      }
      if (Number(this.totalEntries) === Number(32) || Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
        let sixthIndex = 1;
        let sixthRound = Number(fifthRound) / 2;
        for (let i = 0; i < sixthRound; i++) {
          this.sixthRoundArray.push({ index: sixthIndex });
          sixthIndex = sixthIndex + 32;
        }
        if (Number(this.totalEntries) === Number(64) || Number(this.totalEntries) === Number(128)) {
          let seventhIndex = 1;
          let seventhRound = Number(sixthRound) / 2;
          for (let i = 0; i < seventhRound; i++) {
            this.seventhRoundArray.push({ index: seventhIndex });
            seventhIndex = seventhIndex + 64;
          }
          if (Number(this.totalEntries) === Number(128)) {
            let eightIndex = 1;
            let eightRound = Number(seventhRound) / 2;
            for (let i = 0; i < eightRound; i++) {
              this.eightRoundArray.push({ index: eightIndex });
              eightIndex = seventhIndex + 128;
            }
          }
        }
      }

    }
    this.getPlayers(this.selectedAgeGroupId);
  }
  getRoles() {
    let query = "filterByDisable=false&filterByroleName=player";
    this.roleService.getRoleListWithoutAuth(query).subscribe(
      data => {
        if (data.data.items) {
          this.role = data.data.items[0];
          this.roleId = this.role.id;
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getPlayers(selectedAgeGroupId) {
    this.playerList = [];
    let query = "filterByDisabled=false&filterByStatus=true&filterByMatchId=" + this.selectedGroupId + "&filterByAgeGroup=" + selectedAgeGroupId;
    this.tournamentService.getTournamentPlayers(this.tournamentId, query).subscribe(
      data => {
        let playerList = data.items;
        if (playerList.length > 0) {
          playerList.forEach(element => {
            let playerObj = {
              id: element.userId,
              name: element.playerName,
              role: element.playerRole,
              disabled: false
            }
            this.playerList.push(playerObj);
          });
        }
        if (this.playerList.length > 0) {
          let byObj = {
            id: 'bye',
            name: 'Bye',
            disabled: false
          }
          this.playerList.push(byObj);
        }
        // if (this.countForBye == 0) {
        //   this.playerList.push(byObj);
        // } else {
        //   let index = this.findIndexById(byObj.id, this.playerList);
        //   console.log(index);
        //   console.log(this.playerList);
        //   if (index == -1) {
        //     this.playerList.push(byObj);
        //   }
        // }
        this.countForBye++;
        this.getPlayersPositions();
      },
      error => {
      }
    );
  }
  getPlayersPositions() {
    let query = "filterByDisable=false&filterByStatus=true&filterByTournamentId=" + this.tournamentId + "&filterByMatchId=" + this.selectedGroupId + "&filterByAgeGroup=" + this.selectedAgeGroupId;
    this.tournamentDrawService.getTournamentsPlayerPositionList(query).subscribe(
      data => {
        let playerPositionArray = data.data.items;
        if (playerPositionArray.length > 0) {
          playerPositionArray.forEach(element => {
            let setValue = {};
            let playerObj = {};
            let control = 'player' + element.playerPosition;
            let reset = 'reset_' + 'player' + element.playerPosition;
            if (element.isBye === true) {
              let byeId = 'player' + element.playerPosition + "bye";
              setValue = {
                id: 'bye',
                name: 'Bye',
                disabled: false
              }
              playerObj = {
                id: byeId,
                name: 'Bye',
                position: element.playerPosition,
                disabled: false
              }
              this.drawForm.get(control).setValue(setValue);
              this.drawForm.controls[reset].setValue(byeId);
            } else {
              setValue = {
                id: element.playerData[0]._id,
                name: element.playerData[0].fullName,
                role: element.playerRole,
                disabled: false
              }
              this.drawForm.get(control).setValue(setValue);
              this.drawForm.controls[reset].setValue(element.playerData[0]._id);
              let index = this.findIndexById(element.playerData[0]._id, this.playerList);
              if (index !== -1) {
                this.playerList.splice(index, 1);
              }
              playerObj = {
                id: element.playerData[0]._id,
                name: element.playerData[0].fullName,
                position: element.playerPosition,
                role: element.playerRole,
                disabled: false
              }
            }
            let resetPosition = 'reset_' + 'player' + element.playerPosition + "_position";
            this.drawForm.controls[resetPosition].setValue(element.id);
            this.drawForm.get(control).disable();
            this.selectedPlayerList.push(playerObj);
          });
          this.getTournamentResultList();
        }
      },
      err => {
      }
    );
  }
  getTournamentResultList() {
    let query = "filterByDisable=false&filterByStatus=true&filterByTournamentId=" + this.tournamentId + "&filterByMatchId=" + this.selectedGroupId + "&filterByAgeGroup=" + this.selectedAgeGroupId;
    this.tournamentDrawService.getTournamentResultList(query).subscribe(
      data => {
        let roundResult = data.data.items;
        this.roundResult = roundResult;
        let resultLength = roundResult.length;
        if (roundResult.length > 0) {
          roundResult.forEach(element => {
            let round = element.round;
            let nextRound = Number(element.round) + Number(1);
            if (Number(round) === Number(1)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(1);
            }
            if (Number(round) === Number(2)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(2);
            }
            if (Number(round) === Number(3)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(4);
            }
            if (Number(round) === Number(4)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(8);
            }
            if (Number(round) === Number(5)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(16);
            }
            if (Number(round) === Number(6)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(32);
            }
            if (Number(round) === Number(7)) {
              this.formControlNumberOne = element.playerPosition;
              this.formControlNumberTwo = Number(element.playerPosition) + Number(64);
            }
            this.elementRef.nativeElement.querySelector('#winner_id_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = element.id;
            this.elementRef.nativeElement.querySelector('#winner_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = element.winnerFullName;

            this.elementRef.nativeElement.querySelector('#player' + this.formControlNumberOne + '_round' + nextRound).value = element.winnerId;
            let playerSetScoreData = [];
            if (element.matchconcededName !== undefined) {
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).
                insertAdjacentHTML('beforeend', '<div class="player-result">' + element.matchconcededName + '</div>');
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'block';
            } else if (element.score.length > 0) {
              let scoreData = element.score;
              let scoreArray = [];
              let scoreLength = element.score.length;
              let scoreMinutes = 0;
              let showScoreMinutes;
              if (element.score.length > 0) {
                // element.score.forEach(sElement => {
                //   scoreData.push({ score: sElement.player1Set + '-' + sElement.player2Set });
                // });
                for (let i = 0; i < scoreLength; i++) {
                  let playerOneData = scoreData[i].player1Set;
                  let playerTwoData = scoreData[i].player2Set;
                  // scoreMinutes = Number(scoreMinutes) + Number(scoreData[i].duration);
                  if (scoreData[i].player1TieBreak != 0 && scoreData[i].player1TieBreak > scoreData[i].player2TieBreak) {
                    playerOneData = scoreData[i].player1Set + "<sup>" + scoreData[i].player1TieBreak + "</sup>";
                  }
                  if (scoreData[i].player2TieBreak != 0 && scoreData[i].player1TieBreak < scoreData[i].player2TieBreak) {
                    playerTwoData = scoreData[i].player2Set + "<sup>" + scoreData[i].player2TieBreak + "</sup>";
                  }
                  scoreArray.push(playerOneData + '-' + playerTwoData + "  ");
                }
                // if (scoreMinutes == 0) {
                //   showScoreMinutes = '';
                // } else {
                //   showScoreMinutes = " (" + scoreMinutes + "M)";
                // }
                // scoreData['score'] = scoreData[0].player1Set + '-' + scoreData[0].player2Set;
                playerSetScoreData['playerSetScore'] = element.player1val + ' - ' + element.player2val;
                this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span  style="background-color:#11ab63; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;">' + playerSetScoreData['playerSetScore'] + '</span>' + scoreArray.join("") + "</div>");
                // this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).value = ;
              }
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'block';
            } else if (element.score.length === 0 && element.matchconcededName === undefined && element.player1val !== null && element.player2val !== null) {
              playerSetScoreData['playerSetScore'] = element.player1val + ' - ' + element.player2val;
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span class="" style="background-color:#6fc270; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;">' + playerSetScoreData['playerSetScore'] + '</span></div>');
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).style.display = 'block';
            } else {
              this.elementRef.nativeElement.querySelector('#winner_concede_' + 'player' + this.formControlNumberOne + '_' + 'player' + this.formControlNumberTwo + '_round' + round).insertAdjacentHTML('beforeend', '<div class="player-result"><span class="" style="background-color:#6fc270; width:15px;padding: 0.2em 0.6em 0.3em;    font-weight: bold;line-height: 2;    border-radius: 0.25em;white-space: nowrap;    text-align: center;"></span></div>');
            }
          });
        }
      },
      err => {
      }
    );
  }
  findIndexById(id, array) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }

//   printContent(): void { 
//     const printContent = document.getElementById('drawPrint').innerHTML;
//     var printWindow = window.open('', '', 'height=500, width=500'); 
//     printWindow.document.write(
//    ` <html>
//           <head>
//             <title>Print</title>
//             <link rel="stylesheet" type="text/css" href="../../../../assets/css/print.css">
//             <script src="https://cdnjs.cloudflare.com/ajax/libs/print-js/1.6.0/print.js"></script>
//           </head>
//           <body>
//             ${printContent}
//           </body>
//         </html>`
//         )
//         printWindow.document.close(); 
//        printWindow.print(); 
//        this.updateDynamicId();
// } 

// updateDynamicId(): void {
//   this.dynamicId = `winner_player${this.entry.index}_player${this.entry.index + 1}_round1`;
// }
}
